import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Get the current Cognito JWT ID token.
 * Returns null if the user is not authenticated.
 */
export async function getAuthToken() {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() || null;
  } catch (error) {
    console.error('Failed to get auth token:', error);
    return null;
  }
}

/**
 * Wrapper around fetch that automatically includes the Cognito JWT
 * as an Authorization header. Drop-in replacement for fetch().
 */
export async function authFetch(url, options = {}) {
  const token = await getAuthToken();

  const headers = {
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = token;
  }

  return fetch(url, {
    ...options,
    headers,
  });
}
